import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  designId: null,
  title: '',
  message: '',
};

export default class Poster extends Record(defaultValues, Poster) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const Posters = (data) => {
  let poster = new List();
  if (data) {
    data.forEach((value) => {
      poster = poster.push(new Poster(value));
    });
  }
  return poster;
};
